export default __webpack_public_path__ + "static/media/bitstop-co-app-page-redirect.5f0c3fe6.png";